function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import simpleBlockContent from '../fragments/simpleBlockContent.js';
import requiredImage from '../fragments/requiredImage.js';
var schema = defineObject('legacySimulatorStep', {
    icon: {
        title: 'Icon',
        type: 'image',
        validation: function validation(Rule) {
            return Rule.required();
        }
    },
    title: {
        title: 'Title',
        type: 'string',
        validation: function validation(Rule) {
            return Rule.required();
        }
    },
    description: _object_spread({
        title: 'Description'
    }, simpleBlockContent.fragment)
}, []);
var validator = z.object({
    icon: requiredImage.validator,
    title: z.string(),
    description: simpleBlockContent.validator
}).partial();
schema.legacySimulatorStep;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=legacySimulatorStep.js.map